import { Typography } from "@mui/material";

interface ErrorMessageProps {
  isValid: boolean;
  errors: string[];
}

const ErrorMessage = ({ isValid, errors }: ErrorMessageProps) => {
  if (isValid) return null;

  return (
    <Typography
      variant="body2"
      color="error"
      sx={{
        mt: 1,
        fontSize: "0.875rem",
        fontWeight: 400,
      }}
    >
      {errors.map((err) => (
        <div key={err}>{err}</div>
      ))}
    </Typography>
  );
};

export default ErrorMessage;
